module.exports = __webpack_public_path__ + "media/images/search-submit-18971330.gif";